import { createFileRoute } from '@tanstack/react-router'
import ContactOverview from 'Contact/components/Contact/Sections/ContactOverview'

export const Route = createFileRoute('/contact/$contactId/')({
    component: ContactOverview,
})
